// extracted by mini-css-extract-plugin
module.exports = {"scripts":"scripts--KYIyM"};